import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-project-discussion-wrapper',
  templateUrl: './project-discussion-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDiscussionWrapperComponent { }
